// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchInput_search__3JyNd","searchInput":"SearchInput_search-input__1Tm2w","clearBtn":"SearchInput_clear-btn__1LLNd"};